import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras, RouterOutlet } from '@angular/router';
import { LiveInviteTrackingService } from './services/live-invite-tracking.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
  communityId!: string;
  smartcode!: string;
  seqId!: string;
  seqName!: string;
  cognitoId!: string;
  role!: string;
  guid!: string;
  type!: string;
  toAddress!: string;
  firstName!: string;
  lastName!: string;
  to!: string;
  forguid!: string;
  evtype!: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private liveInviteTracking: LiveInviteTrackingService
  ) {}

  ngOnInit() {
    // If we are already on the invite page (e.g. a refresh, bookmark, or the
    // direct community-register?Data=... link), let CommunityRegisterComponent
    // own the URL. Redirecting here would only bounce the user to the empty
    // landing page and pollute history.
    const path = window.location.pathname || '';
    const hasData = !!new URL(window.location.href).searchParams.get('Data');
    if (path.indexOf('community-register') > -1 || hasData) {
      return;
    }

    this.urlExtract();
    if (this.communityId != '' && this.communityId != null) {
      this.liveInviteTracking.setContext({
        communityId: this.communityId,
        inviteGuid: this.guid
      });
      this.liveInviteTracking.record('invite_link_opened', {
        route: '/invite-link',
        metadata: {
          role: this.role || '',
          hasGuid: !!this.guid
        }
      });
      const data = {
        communityId: this.communityId,
        guid: this.guid,
        role: this.role,
        loggedin: false
      };
      const navParam: NavigationExtras = {
        queryParams: {
          Data: JSON.stringify(data)
        },
        // Replace the initial landing-page history entry instead of pushing a
        // new one. This makes community-register the effective "home" for an
        // invite link, so pressing Back returns the user to the app/email that
        // opened the link rather than the empty landing page.
        replaceUrl: true
      };
      this.router.navigate(['community-register'], navParam);
    } else {
      this.router.navigate(['auth/lockscreen'], { replaceUrl: true });
    }
  }

  urlExtract() {
    try {
      const url_string = window.location.href;
      const url = new URL(url_string);
      console.log("URL", url);
      this.communityId = url.searchParams.get('communityId') || '';
      this.role = url.searchParams.get('role') || '';
      this.guid = url.searchParams.get('guid') || '';
      this.type = url.searchParams.get('type') || '';
      this.toAddress = url.searchParams.get('toAddress') || '';
      this.firstName = url.searchParams.get('firstName') || '';
      this.lastName = url.searchParams.get('lastName') || '';
      this.to = url.searchParams.get('to') || '';
      this.forguid = url.searchParams.get('forguid') || '';
      this.evtype = url.searchParams.get('eventype') || '';
      console.log("Community ID", this.communityId);
      console.log("GUID", this.guid);
      console.log("Role", this.role);
      console.log("Logged in", false);  
    } catch (e) {
      console.log('ERROR - urlExtract');
      console.log(e);
    }
  }
}
